import withAPIAction from 'helpers/withAPIAction'
import {
  uploadFileAction,
  getMasterProductAction,
  getManufaturDashboardAction,
  getMerchantSummaryDashboardAction,
  getOverallDashboardAction,
} from './actions'
import { APIPath } from 'services/APIPath'
import { appConfig } from 'config'
import { getRequestString } from 'helpers/format'
import { MasterProducsReq, ManufacturReq, MerchantSummaryReq, OverallDashboardReq } from './types'

export const getMasterProductAPI = (data: MasterProducsReq, token: string) => {
  return withAPIAction<MasterProducsReq>({
    method: 'GET',
    baseUrl: appConfig.backofficeEndpoint,
    path: `${APIPath.rmxGetMasterProduct}?${getRequestString(data)}`,
    data,
    token,
  })(getMasterProductAction)
}

export const getManufacturDashboardAPI = (data: ManufacturReq, token: string, xmid: any) => {
  return withAPIAction<ManufacturReq>({
    method: 'GET',
    baseUrl: appConfig.backofficeEndpoint,
    path: `${APIPath.rmxGetManufacturDashboard}?${getRequestString(data)}`,
    data,
    token,
    xmid,
  })(getManufaturDashboardAction)
}

export const getMerchantSummaryDashboardAPI = (data: MerchantSummaryReq, token: string, xmid: any) => {
  return withAPIAction<MerchantSummaryReq>({
    method: 'GET',
    baseUrl: appConfig.backofficeEndpoint,
    path: `${APIPath.rmxDashboardSummary}?${getRequestString(data)}`,
    data,
    token,
    xmid,
  })(getMerchantSummaryDashboardAction)
}

export const getOverallDashboardAPI = (data: OverallDashboardReq, token: string, xmid: any) => {
  return withAPIAction<OverallDashboardReq>({
    method: 'GET',
    baseUrl: appConfig.backofficeEndpoint,
    path: `${APIPath.overallDashboard}?${getRequestString(data)}`,
    data,
    token,
    xmid,
  })(getOverallDashboardAction)
}

export const uploadFileApi = (data: FormData, token: string, xmid: any) => {
  return withAPIAction<FormData>({
    method: 'POST',
    baseUrl: appConfig.escrowApiEndpoint,
    path: APIPath.rmxUploadFile,
    data,
    token,
    xmid,
  })(uploadFileAction)
}
